import { createRoutes } from "../utils/core";
import ScreenLayout from "../layouts/ScreenLayout";
import UserLayout from "../layouts/UserLayout";
import CommonLayout from "../layouts/CommonLayout";
import IFrameLayout from "@/layouts/IFrameLayout";
import NotFound from "./Pages/404";
import Login from "./account/login";
import Navigation from "./navigation";
import EnergyDeviceList from "./energy/deviceList";
import Energy from "./energy/energy";
import Compare from "./energy/compare";
import ForgetPwd from "./account/forget";
import Register from "./Register";
import Player from "./player";
import intl from "react-intl-universal";
import SecurityLedger from "./SecurityLedger";
import HiddenDanger from "./HiddenDanger";
import Monitor from "./monitor";
import Broadcast from "./broadcast";
import Fire from "./fire";
import ElectricityLayout from "./electricity/layout";

//首页
import Home from "./home";
import Screen from "./screen";
/**
 * 主路由配置
 *
 * path 路由地址
 * component 组件
 * indexRoute 默认显示路由
 * childRoutes 所有子路由
 * NotFound 路由要放到最下面，当所有路由当没匹配到时会进入这个页面
 */
const routesConfig = (app) => [
  {
    path: "/account",
    title: "登录",
    indexRoute: "/account/login",
    component: ScreenLayout,
    childRoutes: [Login(app), ForgetPwd(app), Register(app), NotFound()],
  },
  {
    path: "/navigation",
    title: `导航`,
    component: CommonLayout,
    indexRoute: "/navigation/index",
    childRoutes: [Navigation(app), NotFound()],
  },
  {
    path: "/SecurityLedger",
    title: `安全台账`,
    component: CommonLayout,
    indexRoute: "/SecurityLedger/index",
    childRoutes: [SecurityLedger(app), NotFound()],
  },
  {
    path: "/HiddenDanger",
    title: `隐患管理`,
    component: CommonLayout,
    indexRoute: "/HiddenDanger/index",
    childRoutes: [HiddenDanger(app), NotFound()],
  },
  {
    path: "/energy",
    title: `能效管理`,
    component: ScreenLayout,
    indexRoute: "/energy/index",
    childRoutes: [EnergyDeviceList(app), Energy(app), Compare(app), NotFound()],
  },
  {
    path: "/electricity",
    title: `智慧用电`,
    component: CommonLayout,
    indexRoute: "/electricity/index",
    childRoutes: [ElectricityLayout(app), NotFound()],
  },
  {
    path: "/monitor",
    title: "视频监控",
    component: CommonLayout,
    indexRoute: "/monitor/index",
    childRoutes: [Monitor(app), NotFound()],
  },
  {
    path: "/broadcast",
    title: "应急广播",
    component: CommonLayout,
    indexRoute: "/broadcast/index",
    childRoutes: [Broadcast(app), NotFound()],
  },
  {
    path: "/fire",
    title: "应急广播",
    component: CommonLayout,
    indexRoute: "/fire/index",
    childRoutes: [Fire(app), NotFound()],
  },
  {
    path: "/home",
    title: intl.get("/home"),
    component: ScreenLayout,
    indexRoute: "/home/index",
    childRoutes: [Home(app), NotFound()],
  },
  {
    path: "/screen",
    title: intl.get("/screen"),
    component: ScreenLayout,
    indexRoute: "/screen/index",
    childRoutes: [Screen(app), NotFound()],
  },
  {
    path: "/player",
    title: "播放器",
    component: IFrameLayout,
    indexRoute: "/player",
    childRoutes: [Player(app), NotFound()],
  },
  {
    path: "/sso",
    component: UserLayout,
    childRoutes: [],
  },
  {
    path: "/",
    component: UserLayout,
    childRoutes: [],
  },
];

export default (app) => createRoutes(app, routesConfig);
